<template>
  <div class="pm-dialog-port-vessel">
    <multiselect 
      class="pm-select"
      v-model="selectedVessel"
      placeholder="選択してください"
      selectLabel="選択する"
      selectedLabel="選択済"
      deselectLabel="削除する"
      label="name"
      track-by="id"
      :options="masterVesselList"
      :multiple="false"
    ></multiselect>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

import 'mapbox-gl/dist/mapbox-gl.css'
import Multiselect from 'vue-multiselect';

export default {
  props: {
    showPopup: { type: Boolean, required: true },
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true},
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  components: {
    Multiselect
  },
  data() {
    return {
      selectedVessel: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterVesselList() {
      return this.masterMap['vessels'];
    },
    enableSave() {
      return true; // this.selectedVessel;
    },
  },
  methods: {
    initData() {
      this.selectedVessel = this.valueMap ? this.valueMap.enterprisePortVessel : null;
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = this.selectedVessel ? this.selectedVessel.id : null;
      const index = this.selectedVessel ? this.masterVesselList.findIndex(element => element.id == this.selectedVessel.id) : null
      if (index && this.masterVesselList[index].appendix.head_count != null) {
        const valueStrings = String(this.masterVesselList[index].appendix.head_count).split('')
        updateKeyValueMap['head_count' + '#value'] = valueStrings
        updateKeyValueMap['head_count' + "#color_id"] = valueStrings.map(() => -1)
      } else {
        updateKeyValueMap['head_count' + '#value'] = []
        updateKeyValueMap['head_count' + "#color_id"] = []
      }
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.pm-dialog-port-vessel {
  .pm-select {
    margin: 15px 0px;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

